import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed, toRefs } from "vue"
import { icons } from "@/assets/icons"

import type { IconKey } from "@/assets/icons"

// Типы пропсов
interface Props {
  name: IconKey
  size?: number | string
  color?: string
  class?: string
}

// Значения по умолчанию

export default /*@__PURE__*/_defineComponent({
  __name: 'LibIcon',
  props: {
    name: {},
    size: { default: 20 },
    color: { default: "currentColor" },
    class: { default: "" }
  },
  setup(__props: any) {

console.log("LOADED ICON VALUE:", icons["media/microphone/outline"])
const props = __props

// Нужен toRefs, чтобы TS правильно понимал реактивность
const { name, size, color } = toRefs(props)

// Accept both `:size="16"` and `size="16"` (numeric string): bare numbers get "px".
const cssSize = computed(() => /^\d+(\.\d+)?$/.test(String(size.value)) ? `${size.value}px` : String(size.value))

const svg = computed(() => {
  const value = icons[name.value]
  if (!value && import.meta.env?.DEV) {
    console.warn(`[LibIcon] Icon not found: "${name.value}"`)
  }
  return value
})

return (_ctx: any,_cache: any) => {
  return (svg.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["inline-block", props.class]),
        style: _normalizeStyle({
      width: cssSize.value,
      height: cssSize.value,
      color: _unref(color)
    }),
        innerHTML: svg.value
      }, null, 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})